/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_German13Inputs */

const en__field_enum_subject_german13 = /** @type {(inputs: _Field_Enum_Subject_German13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`German`)
};

const de__field_enum_subject_german13 = /** @type {(inputs: _Field_Enum_Subject_German13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

/**
* | output |
* | --- |
* | "German" |
*
* @param {_Field_Enum_Subject_German13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_german13 = /** @type {((inputs?: _Field_Enum_Subject_German13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_German13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_german13(inputs)
	return de__field_enum_subject_german13(inputs)
});
export { _field_enum_subject_german13 as "_field_enum_SUBJECT_GERMAN" }